import * as S from './styles';

import DropdownOptions from './dropdownOptions';
import MultiSelectToggle from './multiSelectToggle';
import SortToggle from './sortToggle';
import LinkedWidgets from './linkedWidgets';
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'FilterWidgetOptions',
    props: {
        filterWidgetOptions: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        ...mapState('newDashboard', ['dimensions']),
        ...mapGetters('newDashboard', ['tableAdAccountsByGroupId']),
    },
    methods: {
        handleUpdate(key, value) {
            this.handleUpdatePatch({
                [key]: value,
            });
        },
        handleUpdatePatch(patch) {
            const { filterWidgetOptions } = this;

            const updatedFilterWidgetOptions = R.mergeLeft(
                patch,
                filterWidgetOptions
            );

            this.$emit('update', updatedFilterWidgetOptions);
        },
        handleUpdateAvailableLabels(value) {
            this.handleUpdate('availableLabels', value);
        },
        handleUpdateAllowMultiSelect(value) {
            this.handleUpdate('allowMultiSelect', value);
        },
        handleUpdateSortAlphabetically(value) {
            this.handleUpdate('sortAlphabetically', value);
        },
        handleUpdateLinkedWidgetIds(value) {
            this.handleUpdate('linkedWidgetIds', value);
        },
        getDropdownOptionsProps() {
            const {
                filterWidgetOptions,
                handleUpdateAvailableLabels,
                handleUpdate,
            } = this;
            const { availableLabels, subType, groupId, by, condition, values } =
                filterWidgetOptions;
            const _availableLabels = availableLabels;

            const dropdownOptionsProps = {
                props: {
                    compKey: 'dropdownOptions',
                    availableLabels: _availableLabels,
                    handleUpdateAvailableLabels,
                    subType,
                    groupId,
                    by,
                    condition,
                    values,
                    handleUpdate,
                    handleUpdatePatch: this.handleUpdatePatch,
                },
                on: {
                    'outsideClick:active': (v) => {
                        this.$emit('outsideClick:active', v);
                    },
                },
            };
            return dropdownOptionsProps;
        },
        getMultiSelectToggleProps() {
            const { filterWidgetOptions, handleUpdateAllowMultiSelect } = this;
            const { allowMultiSelect } = filterWidgetOptions;

            const multiSelectToggleProps = {
                props: {
                    allowMultiSelect,
                    handleUpdateAllowMultiSelect,
                },
            };
            return multiSelectToggleProps;
        },
        getSortToggleProps() {
            const { filterWidgetOptions, handleUpdateSortAlphabetically } =
                this;
            const { sortAlphabetically } = filterWidgetOptions;

            const sortToggleProps = {
                props: { sortAlphabetically, handleUpdateSortAlphabetically },
            };
            return sortToggleProps;
        },
        getLinkedWidgetsProps() {
            const { filterWidgetOptions, handleUpdateLinkedWidgetIds } = this;
            const { linkedWidgetIds } = filterWidgetOptions;

            const linkedWidgetsProps = {
                props: {
                    compKey: 'linkedWidgets',
                    linkedWidgetIds,
                    handleUpdateLinkedWidgetIds,
                },
                on: {
                    'outsideClick:active': (v) => {
                        this.$emit('outsideClick:active', v);
                    },
                },
            };
            return linkedWidgetsProps;
        },
        hasUnsavedOpenPanel() {
            const { dropdownOptions, linkedWidgets } = this.$refs;
            return Boolean(
                dropdownOptions?.hasUnsavedOpenPanel?.() ||
                    linkedWidgets?.hasUnsavedOpenPanel?.()
            );
        },
        requestCloseWithConfirm(onProceed) {
            const { dropdownOptions, linkedWidgets } = this.$refs;
            const target =
                (dropdownOptions?.hasUnsavedOpenPanel?.() && dropdownOptions) ||
                (linkedWidgets?.hasUnsavedOpenPanel?.() && linkedWidgets);

            if (target) {
                target.requestCloseWithConfirm(onProceed);
                return;
            }

            onProceed();
        },
    },

    render() {
        const dropdownOptionsProps = this.getDropdownOptionsProps();
        const multiSelectToggleProps = this.getMultiSelectToggleProps();
        const sortToggleProps = this.getSortToggleProps();
        const linkedWidgetsProps = this.getLinkedWidgetsProps();

        return (
            <S.OptionsWrapper>
                <DropdownOptions
                    ref="dropdownOptions"
                    {...dropdownOptionsProps}
                />
                <SortToggle {...sortToggleProps} />
                <MultiSelectToggle {...multiSelectToggleProps} />
                <LinkedWidgets ref="linkedWidgets" {...linkedWidgetsProps} />
            </S.OptionsWrapper>
        );
    },
};
